import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateOriginalWebUrl = new ReduxAsyncAction<'UPDATE_ORIGINAL_WEB_URL', string, { originalWebUrl: string }>(
  'UPDATE_ORIGINAL_WEB_URL'
);

UpdateOriginalWebUrl.registerRequest(async (originalWebUrl: string) => {
  return { originalWebUrl };
});

export const UPDATE_ORIGINAL_WEB_URL = UpdateOriginalWebUrl.actionNamespaceConstants;
export const updateOriginalWebUrl = UpdateOriginalWebUrl.request;

export type UpdateOriginalWebUrlResponseAction = Action<typeof UPDATE_ORIGINAL_WEB_URL.response> & {
  data: { originalWebUrl: string };
};
